// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { AxiosError, AxiosResponse } from 'axios';
import { ofType } from 'redux-observable';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { ActionType, getType } from 'typesafe-actions';

import { getExamInformation } from '../../apis/exam';
import { ExamInformation } from '../../types/Model';
import { getExamInformationActions } from '../actionCreators/getExamInformationActions';
import { RootAction } from '../rootActionCreator';
import { RootState } from '../rootReducer';

const outputActions = {
  success: getExamInformationActions.success,
  failure: getExamInformationActions.failure
};

type RequestActionTypes = ActionType<typeof getExamInformationActions.request>;
type OutputActionTypes = ActionType<typeof outputActions>;

export const getExamInformationEpic = (
  action$: Observable<RootAction>,
  _state$?: Observable<RootState>
): Observable<OutputActionTypes> => {
  return action$.pipe(
    ofType(
      // action filter
      getType(getExamInformationActions.request)
    ),
    switchMap((action: RequestActionTypes) => {
      // prepare api params
      const { id, condition, workshopId, iltCourseId } = action.payload;
      // send api promise
      return getExamInformation(id, condition, workshopId, iltCourseId)
        .then((response: AxiosResponse<ExamInformation>) => {
          // handle success case here
          return getExamInformationActions.success({
            examInformation: response.data
          });
        })
        .catch((error: AxiosError) => {
          // handle error case here
          switch (error.response?.status) {
            case 401:
              return getExamInformationActions.failure({
                error: error.response?.request.response
              });
            case 404:
              return getExamInformationActions.failure({
                error: error.response?.request.response
              });
            case 403:
              return getExamInformationActions.failure({
                error: new Error('該考試目前無法提供使用，請選擇其他考試。')
              });
            default:
              return getExamInformationActions.failure({
                error: new Error('系統出現暫時性的錯誤，請點擊再次嘗試。')
              });
          }
        });
    })
  );
};
